import 'intl-tel-input/build/css/intlTelInput.css';
import IntlTelInput from 'intl-tel-input/react/build/IntlTelInput.esm';
import '../../node_modules/intl-tel-input/build/js/utils';

const PhoneField = ({ handleChange, error, value }) => {
	const searchLabel = window.post_template?.checkout_v3_form.checkout_v3_formLabels?.tr_checkout_v3_form_searchLabel;

	return (
		<div className="input-container" style={{ width: '100%', height: '100%' }}>
			<div className={error ? 'input input--error' : 'input'} style={{ padding: '0px' }}>
				<IntlTelInput
					initialValue={value}
					onChangeNumber={(value) => {
						handleChange(value);
					}}
					autoComplete={'tel'}
					initOptions={{
						initialCountry: window.countryCode.toUpperCase(),
						showSelectedDialCode: true,
						autoPlaceholder: 'aggressive',
						nationalMode: false,
						countrySearch: true,
						i18n: {
							searchPlaceholder: searchLabel,
						},
					}}
				/>
			</div>
			{error && <div className="formError">{error}</div>}
		</div>
	);
};

export default PhoneField;
